import React from "react";
import classNames from "classnames";
import { BranchesOutlined } from "@ant-design/icons";
import { IFamilyExtNode } from "relatives-tree/lib/types";
import styles from "./FamilyNode.module.css";
import { FamilyTreeNodeItem } from "../../components";

interface Props {
  node: IFamilyExtNode;
  isRoot: boolean;
  onSubClick: (id: string) => void;
  style?: React.CSSProperties;
}

const FamilyNode: React.SFC<Props> = (props) => {
  return (
    <div className={styles.root} style={props.style}>
      <div
        className={classNames(
          styles.inner,
          styles[props.node.gender],
          props.isRoot && styles.isRoot
        )}
      >
        {props.children}
      </div>
      {props.node.hasSubTree && (
        <FamilyTreeNodeItem onClick={() => props.onSubClick(props.node.id)}>
          <BranchesOutlined />
        </FamilyTreeNodeItem>
      )}
    </div>
  );
};
export default FamilyNode;
